"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.array.find.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
require("core-js/modules/es6.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _apollo = require("@nerdwallet/apollo");
var _currency = require("@nerdwallet/currency");
var _apyDriver = _interopRequireDefault(require("./apy-driver"));
var _templateObject;
var CdApyDrivers = function CdApyDrivers(_ref) {
  var drivers = _ref.drivers;
  var minBalanceDriver = drivers.find(function (driver) {
    return driver.id === 'minimumBalance';
  });
  var apyDrivers = drivers.filter(function (driver) {
    return driver.id.includes('apy') && driver.value;
  });
  if (apyDrivers.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_currency.Text, null, "N/A");
  }
  return /*#__PURE__*/_react.default.createElement(_currency.Stack, {
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_currency.Box, {
    borderBottom: 1,
    borderColor: "neutral-lighter",
    marginBottom: 0
  }, /*#__PURE__*/_react.default.createElement(_currency.Columns, null, /*#__PURE__*/_react.default.createElement(_currency.Column, {
    width: "3"
  }, /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small",
    tone: "light"
  }, minBalanceDriver.label)), /*#__PURE__*/_react.default.createElement(_currency.Column, {
    width: "9"
  }, /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Text, null, minBalanceDriver.value), minBalanceDriver.valueTooltip && /*#__PURE__*/_react.default.createElement(_currency.Tooltip, {
    placement: "bottom",
    content: minBalanceDriver.valueTooltip
  })), /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small",
    tone: "light"
  }, minBalanceDriver.description))))), /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Columns, null, /*#__PURE__*/_react.default.createElement(_currency.Column, {
    width: "3"
  }, /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small",
    tone: "light"
  }, "APY")), /*#__PURE__*/_react.default.createElement(_currency.Column, {
    width: "9"
  }, apyDrivers.map(function (driver, index) {
    var lastIndex = apyDrivers.length - 1;
    return /*#__PURE__*/_react.default.createElement(_apyDriver.default, {
      driver: driver,
      key: driver.id,
      renderDivider: index !== lastIndex
    });
  })))));
};
CdApyDrivers.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment CdApyDrivers on MarketplaceEntityInterface {\n    ...ApyDriver\n  }\n\n  ", "\n"])), _apyDriver.default.fragment);
var _default = CdApyDrivers;
exports.default = _default;